import { ReactNode } from "react";

import styles from "./styles.module.scss";

export type ContainerProps = {
  children: ReactNode;
};

const Container = ({ children }: ContainerProps) => (
  <div className={styles.wrapper}>{children}</div>
);

export default Container;
